// Mock Users
export let mockUsers = [
    { id: 'u1', name: 'Admin User', email: 'admin@example.com', role: 'administrator', password: 'password123', createdAt: new Date(2023, 9, 1) },
    { id: 'u2', name: 'Manager User', email: 'manager@example.com', role: 'manager', password: 'password123', createdAt: new Date(2023, 9, 5) },
    { id: 'u3', name: 'Viewer User', email: 'viewer@example.com', role: 'viewer', password: 'password123', createdAt: new Date(2023, 9, 10) },
];

// Mock Quotes (Ensure createdAt exists)
export let mockQuotes = [
    { id: 'q1', name: 'Alice Johnson', email: 'alice@test.com', phone: '1112223333', projectType: 'webApp', message: 'Need a web app for...', status: 'Pending', createdAt: new Date(2023, 10, 15), submitterId: 'u1' },
    { id: 'q2', name: 'Bob Williams', email: 'bob@test.com', phone: '4445556666', projectType: 'mobileApp', message: 'Mobile app requirements...', status: 'Confirmed', createdAt: new Date(2023, 10, 20), submitterId: 'u2' },
    { id: 'q3', name: 'Charlie Brown', email: 'charlie@test.com', phone: '7778889999', projectType: 'landingPage', message: 'Simple landing page quote.', status: 'Rejected', createdAt: new Date(2023, 11, 1), submitterId: 'u1' },
    { id: 'q4', name: 'Diana Prince', email: 'diana@test.com', phone: '1231231234', projectType: 'eCommerce', message: 'E-commerce platform details', status: 'Processing', createdAt: new Date(2023, 11, 5), submitterId: 'u2' },
];

// Function to simulate ID generation
let nextQuoteId = 5;
let nextUserId = 4;
export const generateQuoteId = () => `q${nextQuoteId++}`;
export const generateUserId = () => `u${nextUserId++}`;

// Functions to allow modification (used by mock services)
export const updateMockQuotes = (newQuotes) => {
    console.log("Updating mockQuotes:", newQuotes);
    mockQuotes = newQuotes;
};
export const updateMockUsers = (newUsers) => {
    console.log("Updating mockUsers:", newUsers);
    mockUsers = newUsers;
};

// Mock Stats Data (Add this)
export const mockStats = {
    totalQuotes: mockQuotes.length,
    pendingQuotes: mockQuotes.filter(q => q.status === 'Pending').length,
    totalUsers: mockUsers.length,
    projectsInProgress: 5, // Example static stat
};

// Mock Notifications (Add this) - Updated with details
export let mockNotifications = [
    {
        id: 'n1',
        type: 'quote_received',
        message: 'New quote received from Alice Johnson for Web App.', // Slightly more info
        details: 'Quote ID: q1. Project Type: webApp. Status: Pending. Needs review.',
        timestamp: new Date(2023, 10, 15, 10, 30),
        read: false
    },
    // { id: 'n2', type: 'user_added', message: 'Manager User was added to the system.', details: 'User ID: u2. Role: manager.', timestamp: new Date(2023, 9, 5, 11, 0), read: true }, // Commenting out non-quote notifications for now based on requirement
    {
        id: 'n3',
        type: 'quote_status_change', // Keeping this as an example, but focus on 'quote_received' for new ones
        message: 'Quote q2 status changed to Confirmed.',
        details: 'Quote ID: q2 (Bob Williams). Status changed from Pending to Confirmed.',
        timestamp: new Date(2023, 10, 21, 9, 0),
        read: false
    },
    {
        id: 'n4',
        type: 'quote_received',
        message: 'New quote received from Charlie Brown for Landing Page.',
        details: 'Quote ID: q3. Project Type: landingPage. Status: Pending. Needs review.',
        timestamp: new Date(2023, 11, 1, 14, 15),
        read: true // Example of an already read one
     },
];

// Function to allow modification (e.g., adding new notifications, deleting)
export const updateMockNotifications = (newNotifications) => {
    console.log("Updating mockNotifications:", newNotifications);
    mockNotifications = newNotifications;
};

// Note: Ensure your quote creation service/logic calls a function (like below, but placed appropriately)
// to add a new notification to `mockNotifications` when a quote is successfully submitted.
// Example function (to be called from elsewhere, e.g., QuoteService):
/*
export const addQuoteNotification = (quote) => {
    const newNotification = {
        id: `n${Date.now()}`, // Simple unique ID generation
        type: 'quote_received',
        message: `New quote received from ${quote.name} for ${quote.projectType}.`,
        details: `Quote ID: ${quote.id}. Status: ${quote.status}. Needs review.`,
        timestamp: new Date(),
        read: false
    };
    mockNotifications.unshift(newNotification); // Add to the beginning
    updateMockNotifications([...mockNotifications]); // Trigger update if needed (depends on direct usage vs service)
    console.log("Added notification for new quote:", quote.id);
};
*/

// Mock Messages (Add this)
export const mockMessages = [
    { id: 'm1', sender: 'Alice Johnson (q1)', subject: 'Question about Web App Quote', snippet: 'Could you clarify the timeline...', timestamp: new Date(2023, 10, 16, 14, 0), read: false },
    { id: 'm2', sender: 'Bob Williams (q2)', subject: 'Mobile App Confirmation', snippet: 'Thanks for confirming, proceeding...', timestamp: new Date(2023, 10, 22, 11, 30), read: true },
];

// Mock Projects (Add this)
export const mockProjects = [
    { id: 'p1', name: 'Web App for Alice', relatedQuoteId: 'q1', status: 'In Progress', startDate: new Date(2023, 11, 1), managerId: 'u2' },
    { id: 'p2', name: 'Mobile App for Bob', relatedQuoteId: 'q2', status: 'Completed', startDate: new Date(2023, 11, 10), completionDate: new Date(2024, 1, 15), managerId: 'u2' },
];